/**
 * @ngdoc services
 * @memberof mercury.modules.time.payroll.paytypes.allowance
 * @name TimePayrollAllowance
 * @description Data access service for managing allowance types
 */
angular.module('mercury.modules.time.payroll.paytypes.allowance')
.factory('TimePayrollAllowance', ["$resource", "settings", function($resource, settings) {
  var Paytypes = $resource(settings.apiHost + '/r/TimePayrollPaytypes/:id', {id: '@id'});

  /**
   * Get a list of all allowances
   *
   * @memberof TimePayrollAllowance
   */
  function getAll() {
    return Paytypes.query({module: 1}).$promise;
  }

  /**
   * Update or create a given allowance
   *
   * @memberof TimePayrollAllowance
   * @param  {Object} allowance Allowance model
   */
  function save(allowance) {
    allowance.module = 1;
    if (allowance.id) {
      return Paytypes.update(allowance).$promise;
    } else {
      return Paytypes.save(allowance).$promise;
    }
  }

  return {
    getAll: getAll,
    save: save
  };
}]);
